import { ComponentTag } from '../shared/component-tag.style';
import Icon360 from 'approot/shared/icons/icon-360';

const ImageSphereTag = () => (
  <ComponentTag data-selector="component-tag">
    <Icon360 width={12} height={12} />
    <span>360° Image</span>
  </ComponentTag>
);

export default ImageSphereTag;
